import * as Yup from 'yup';

export const phoneNumberValidator = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Mobile phone number is required')
    .test(
      'is-phoneNumber',
      'Not a valid mobile phone number',
      (value) =>
        !!(
          value &&
          value.length > 9 &&
          value.length < 14 &&
          /^\+[0-9]*|^0[0-9]*$/.test(value)
        ),
    ),
});
